import { ReactNode } from 'react';
import { useMediaQuerySSR } from 'src/hooks/useStateSSR';
import theme from 'src/utils/theme';
import { useLanguagePairContext } from 'src/context/languagePair';
import { getLocaleBackgroundImage } from './utils/getLocaleBackgroundImage';
import * as S from './styles';

type Props = {
  children: ReactNode;
};

export const TargetLocaleBackground = ({ children }: Props) => {
  const isMobile = useMediaQuerySSR(false, { maxWidth: theme.sz.md });
  const { targetLanguageLocale } = useLanguagePairContext();

  return (
    <S.Background
      data-testid={`${targetLanguageLocale}-background`}
      $src={getLocaleBackgroundImage(isMobile ? 'mobile' : 'desktop', targetLanguageLocale)}
    >
      {children}
    </S.Background>
  );
};
